const Star = () => (
	<svg
		width="13"
		height="12"
		viewBox="0 0 13 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M5.85248 0.417179L4.3787 3.5203L1.0813 4.01952C0.489985 4.10859 0.253006 4.86562 0.681825 5.29921L3.06741 7.71327L2.50318 11.1234C2.40162 11.7398 3.02679 12.2016 3.5504 11.9133L6.50023 10.3031L9.45005 11.9133C9.97366 12.1992 10.5988 11.7398 10.4973 11.1234L9.93304 7.71327L12.3186 5.29921C12.7474 4.86562 12.5105 4.10859 11.9191 4.01952L8.62175 3.5203L7.14797 0.417179C6.88391 -0.135946 6.1188 -0.142977 5.85248 0.417179Z" />
	</svg>
);

export default Star;



// WEBPACK FOOTER //
// ./src/js/app/icons/star.js